type ReorderFnArgs<T> = { src: Array<T>; start: number; end: number };

export function reorder<T>({ src, start, end }: ReorderFnArgs<T>): Array<T> {
  if (start < 0 || start >= src.length) return src;
  const result = Array.from(src);
  const [removed] = result.splice(start, 1);
  result.splice(end, 0, removed);
  return result;
}
